import { render, staticRenderFns } from "./ModalEspaceClient.vue?vue&type=template&id=1dd1d1a6&scoped=true&"
import script from "./ModalEspaceClient.vue?vue&type=script&lang=js&"
export * from "./ModalEspaceClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalEspaceClient.vue?vue&type=style&index=0&id=1dd1d1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd1d1a6",
  null
  
)

export default component.exports